import { render, staticRenderFns } from "./prop-editor.vue?vue&type=template&id=51587132&scoped=true&"
import script from "./prop-editor.vue?vue&type=script&lang=js&"
export * from "./prop-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51587132",
  null
  
)

export default component.exports